import script from "./ListDocuments.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListDocuments.vue?vue&type=script&setup=true&lang=ts"

import "./ListDocuments.vue?vue&type=style&index=0&id=0433e965&lang=css"

const __exports__ = script;

export default __exports__